/****************************************************************************/
/* File:        OPGChart.js                                                 */
/* Ver:         2.2.8                                                       */
/* Date:        01-04-2019                                                  */
/* Author:      Goce Jankuloski | goce.jankuloski@opg.com                   */
/* Description: JavaScript library class for standard OPG Charts used to    */
/*              plot data on HTML pages, using Chart.JS as backbone         */
/* Dependencies:                                                            */
/*      - Chart.JS                      Version: 2.7.3                      */
/*      - Chart.JS Annotation Plugin    Version: 0.5.7                      */
/*      - Chart.JS Zoom Plugin          Version: 0.7.0                      */
/*      - Chart.JS Datalabels Plugin    Version: 0.2.0                      */
/*      - Hammer.JS                     Version: 2.0.8                      */
/*      - jQuery                        Version: 3.3.1                      */
/*      - Moment                        Version: 2.23.0                     */
/* Note: refer to package.json file for latest version of dependencies      */
/*                                                                          */
/* Version Note:                                                            */
/*      - 2.2.8:upgraded chartjs-plugin-zoom verison to latest@0.7.0 to fix */
/*              issue with error when doing first zoom at parseOffset       */
/*      - 2.2.5:added ability to add CustomHorizontalStepSize function      */
/*              for determining the time step size                          */
/*      - 2.2.4:removed moment-timezone as timezone should be set by parent */
/*              app/library                                                 */
/*      - 2.2.3:added moment-timezeone and fixed some bugs so it can be used*/
/*              in case we need to change timezones                         */
/*      - 2.2.2:fix so that y values are filtered only if user specifies    */
/*              such value in chartOptions                                  */
/*      - 2.2.1:updated dependencies by running npm update. Using Chart.js  */
/*              2.7.3. Bumping version to 2.2.1 for now                     */
/*      - 2.2.0:allow user to specify legend onclick function allowing      */
/*              tracking of which datasets have been toggled on/off         */
/*              Added function GetDatasetsVisibilityIndices to get current  */
/*              datasets indices that are visible                           */
/*      - 2.1.2:minor fix to not crush when settin server data if ids is not*/
/*              supplied as part of the object                              */
/*      - 2.1.1:adjustment so that in UpdateDataForChart, if dataset has no */
/*              points, don't add it to the chart for graphing              */
/*              Added filter to remove any datasets with no data inside them*/
/*      - 2.1.0:changes to code to make it compatible with ES6 and so it can*/
/*              be used in SPA applications                                 */
/*              New option in OPGChartOptions, allowing for toggling of     */
/*              legend clicking determining visibility of datasets          */
/*              Added stepFactor option in OPGChartOptions scales y axes    */
/*              which determines the max and min limits for y axes ensuring */
/*              that the limits fall on a multiple of stepFactor            */
/*	            Also added function to calibrate y axis ticks when they are */
/*              generated to make sure they align with the step size that   */
/*              was computed after a chart update                           */
/*	            Fixed all '==' and '!==' warnings so that code runs faster  */
/*	            Reordered the arguments passed to OPGChart when             */
/*	            instantiating new object - options first, canvas is optional*/
/*              second                                                      */
/*              Fixed y gridlines calibration to ensure no gridlines outside*/
/*              of max and min are included. Also made changes to how the   */
/*              calculation to determine whether a tick is on the right     */
/*              value is done - for stepSizes less than 1                   */
/*              Fixed x gridlines calibration - rewrote so that new labels  */
/*              are generated in place instead of trying to calculate an    */
/*              offset                                                      */
/*      - 2.0.1:changed the dateTimeRetriever return type to Date object    */
/*              instead of moment in order to reduce the memory footprint   */
/*      - 2.0.0:rewrite of code so it conforms to ES2015+ standard. No      */
/*              longer relies on AMD or requireJS, instead relies on webpack*/
/*              and babel to compile the code into IE11+ compatible JS      */
/*              Fixed functions with undeclared variables.                  */
/*              Removed previousMin and previousMax vars - no longer used   */
/*      - 1.9.2:fix to the CalibrateXGridlines function so that it          */
/*              doesn't use referenceDate if it's not set for the chart     */
/*              instead it uses the first point or startDate                */
/*      - 1.9.1:small fix to the way major labels are generated on y axis   */
/*              so that we don't get a major label on the top or bottom     */
/*              tick if it is not on a major gridline number (i.e x.x5)     */
/*      - 1.9:  minor change to consolidate OPGChart so that all variables  */
/*              required for gridlines are inside the chart options object  */
/*      - 1.8:  MAJOR CHANGE - due to memory leaking with constant updating */
/*              of chart, found out that creating new Chart object every    */
/*              update causes memory leak. Instead function has been changed*/
/*              to just update chart with new data and modify chart options */
/*              in place.                                                   */
/*              - Also consolidated some of the variables like currentAxes  */
/*              into the chart.options object for easier handling           */
/*      - 1.7:  Rewrote callback for generating labels for x axis so that   */
/*              labels are generated and aligned so that referenceDate      */
/*              falls on major gridline                                     */
/*              Rewrote the major gridline feature internally so that       */
/*              a second redraw is not needed for every change in chart's   */
/*              pan/zoom. This added performance gains to responsiveness    */
/*              of chart, when major gridlines option is enabled            */
/*              - Also fixed issue with y ticks when y range was evenly     */
/*              divisible by the step size, so that pannning works          */
/*      - 1.6.1:Added ability for major vertical gridlines, similar to ones */
/*              for horizontal gridlines. Refactored the plugin code for    */
/*              major gridline and how the annotations are updated so we    */
/*              don't lose the annotation labels                            */
/*      - 1.6:  Rewrote the chart plugins so that the ones that are specific*/
/*              to this individual chart are not registered globally        */
/*              This will allow for multiple charts on single page without  */
/*              any intereference between the charts                        */
/*              Minor Fixes:                                                */
/*               * fix calculation of major ticks when panning remain       */
/*                  even (i.e. 0._5 or 0._0)                                */
/*      - 1.5:  Added ability for user to specify minor gridline stepsize   */
/*              Also changed the way major gridlines are calculated so that */
/*              they always happen on 0._0 or 0._5.                         */
/*              MUCH improved performance over 1.5 as there was a bug       */
/*              afterDatasetDraw should have been afterDatasetsDraw to      */
/*              only do one extra draw per chart redraw                     */
/*              added dynamicStepSize for yAxes ticks, so that stepSize     */
/*              (minor) is calculated only if this is set to true           */
/*      - 1.4:  Modified SetChartData function so that user can pass        */
/*              whether they want the axes to be resized based on the new   */
/*              data or keep the current view (zoom, pan) the same          */
/*           * Added marginBottom and marginTop to the OPGChartOptions      */
/*              so user can specify how many units they want to keep        */
/*              between max min data points and the boudns of chart         */
/*           * Fixed a bug where sometimes the wrong major gridlines        */
/*              would be labeled.                                           */
/*           * Allows for major y gridlines to be coloured differently      */
/*              by setting majorEnabled option to true in OPGChartOptions   */
/*      - 1.3:  Adding ability for user to update userOptions through a     */
/*              public function - SetUserChartOptions. GetUserChartOptions  */
/*              also added to allow caller to get latest copy of options    */
/*              The SetUserChartOptions does not call UpdateChart. Caller   */
/*              responsible for calling it after making changes to optins   */
/*      - 1.2:  Minor upgrade that allows user of class to specify the      */
/*              horizontal time limits through UpdateHorizontalAxies fn     */
/*              Also ResizeVerticalAxis changed to only resize based on     */
/*              the data that is in the horizontal time range               */
/*              Also added GetHorizontalAxisLimits public fn to be able     */
/*              to get the chart's current min and max time                 */
/*      - 1.1:  Minor revision to v1.1, to address an issue when zooming    */
/*              is done to excessive degree the stepSize was not updated to */
/*              reflect the changes in limits, and hence it became too      */
/*              crowded with gridlines.                                     */
/*      - 1.0:  First version of this OPGChart class library. Code used     */
/*              in RTDM and FlowForecast was taken and modularized and set  */
/*              up as a class, with variety of options to allow user        */
/*              to easily create a chart. Some of the options are:          */
/*              - Drawing series with cursor                                */
/*              - Shifting in x, y, or both directions                      */
/*              - Customize ability to zoom/pan in x, y, or both directions */
/*              - Customize chart title, axes labels, fonts etc.            */
/*              - Refer to OPGChartOptions for more detail                  */
/****************************************************************************/
import $ from 'jquery';
import moment from 'moment';
import 'hammerjs';
import { Chart as ChartJS } from 'chart.js';
import 'chartjs-plugin-annotation';
import 'chartjs-plugin-zoom';

/****************************************************************************/
/* Class:       OPGChartOptions                                             */
/* Ver:         1.0                                                         */
/* Date:        08-03-2018                                                  */
/* Description: Helper JS class that allows for flexible customization of   */
/*              OPGChart including things like background colours, axis and */
/*              char ttitle, drawing, shifting options. It follows the      */
/*              naming convention of Chart.JS Option structure, for easier  */
/*              compatibility. Non standard options are identified with a   */
/*              comment below.                                              */
/****************************************************************************/
const Options =  function() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    chartArea: {
      backgroundColor: 'rgba(227, 227, 227, 1)'
    },
    animation: {
      duration: 0,
    },
    title: {
      fontColor: '#000',
      fontSize: 18,
      fontFamily: 'Arial',
      display: true,
      text: "Chart Title"
    },
    legend: {
      toggle: true,
      onClick: null,
      position: 'bottom',
      display: true,
    },
    layout: {
      padding: {
        left: 0,
        right: 15,
        top: 0,
        bottom: 0
      }
    },
    scales: {
      yAxes: [{
        // OPG chart custom option:            
        // - how much margin to add between max and min data points and the chart bounds
        marginTop: 0.05,
        marginBottom: 0.05,
        stepFactor: 0.05,   // on what value is it acceptable to have the max and min y axies values at
        // invalid value filtering
        invalidValue: undefined, // set to undefined if don't want filtering
        color: "#000",
        gridLines: {
          // OPG chart custom option:
          // - whether to enable colouring of major gridlines with diff colour:
          majorEnabled: false,
          majorColour: '#696969',

          display: true,
          tickMarkLength: 6,
          drawBorder: true,
          color: "#A9A9A9",
          lineWidth: 0.5,
          zeroLineColor: "#000",
        },
        ticks: {
          max: 174.6,
          min: 174.1,
          // step size of minor tick
          stepSize: 0.01,
          fontColor: '#000000',
          fontSize: 14,
          fontFamily: 'Arial',
          beginAtZero: false,
          // OPG chart custom option:
          // - how many minor ticks for every major
          minorToMajor: 5,
          // - whether the stepSize will be recalculated for every
          // refresh, zoom of the chart
          dynamicStepSize: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Y-axes label',
          fontColor: '#000',
          fontSize: 16,
          fontFamily: 'Arial',
        },
      }],
      xAxes: [{
        // OPG chart custom option:
        // - how many units to leave between last data point and end of chart
        numUnitsToMaxTime: 8,
        numUnitsToMinTime: 48,
        color: "#000",
        type: 'time',
        distribution: 'series',
        scaleLabel: {
          display: true,
          labelString: 'X-Axes label',
          fontColor: '#000',
          fontSize: 16,
          fontFamily: 'Arial',
        },
        ticks: {
          fontColor: '#000000',
          fontSize: 12,
          fontFamily: 'Arial',
          autoSkip: false,
          maxRotation: 0,
          referenceHourEnabled: false,
          // how many minor ticks for every major
          minorToMajor: 4,
          // - whether the stepSize will be recalculated for every
          // refresh, zoom of the chart
          dynamicStepSize: false,
        },
        gridLines: {
          // OPG chart custom option:
          // - whether to enable colouring of major gridlines with diff colour:
          majorEnabled: false,
          majorColour: '#696969',
          display: true,
          tickMarkLength: 4,
          drawBorder: true,
          color: "#A9A9A9",
          zeroLineColor: "#000",
          lineWidth: 0.5,
        },
        time: {
          round: false,
          unit: 'hour',
          unitStepSize: 1,
          displayFormats: {
            'millisecond': 'H',
            'second': 'H',
            'minute': 'H',
            'hour': 'H',
          },
        },
      }]
    },
    annotation: {
      annotations: []
    },
    tooltips: {
      enabled: false,
    },
    // custom option created by GJ, for setting up
    // chart so that it can allow redraw of points, and shifting 
    draw: {
      enabled: true,
      datasetIndex: 0,
      thickness: 2,
      color: 'red',
    },
    // OPG chart custom option:
    // - allows shifting of dataset in either or x/y direction
    shift: {
      enabled: true,
      datasetIndex: 0,
      mode: 'xy',
    },

    // Zoom options
    zoom: {
      // Boolean to enable zooming
      enabled: true,
      // Zooming in all directions.
      mode: 'xy',
      rangeMin: {
        // Format of min pan range depends on scale type
        x: null,
        y: null
      },
      rangeMax: {
        // Format of max pan range depends on scale type
        x: null,
        y: null
      }
    },
    // Pan options
    pan: {
      // enable pan
      enabled: true,
      // Panning  directions. 
      mode: 'xy',

      rangeMin: {
        // Format of min pan range depends on scale type
        x: null,
        y: null
      },
      rangeMax: {
        // Format of max pan range depends on scale type
        x: null,
        y: null
      }
    },
    // plugins options
    plugins: {
      datalabels: {
        display: false,
      }
    },
  }
};

/****************************************************************************/
/* Class:       OPGChartDatasetProperties                                */
/* Ver:         1.0                                                      */
/* Date:        08-03-2018                                               */
/* Description: Helper JS class that allows for flexible customization of   */
/*              OPGChart chart datasets properties for display purposes     */
/****************************************************************************/
const DatasetProperties = function () {
  return {
    lineColour: 'yellow',
    pointStyle: '',
    pointColour: '#000',
    borderWidth: 2,
    pointBorderWidth: 2,
    pointHoverRadius: 5,
    pointRadius: 5,
    pointHitRadius: 4,
  }
};


/****************************************************************************/
/* Class:       OPGChart                                                 */
/* Ver:         1.1                                                      */
/* Date:        06-04-2018                                               */
/* Description: JS class responsible for taking JSON represented datasets   */
/*              and displaying it via Chart.JS type chart. OPGChart allows  */
/*              for easy instantiation of timeline based charts, and     */
/*              flexible customization that allows things like, zoom, pan,  */
/*              moving of parts of a dataset, and shifting.              */
/****************************************************************************/
const Chart = function(options, canvasDOMElement) {
  /*************************************************************************/
  /*  PRIVATE VARIABLES                                                 */
  /*  These are private variables that are used by different internal      */
  /*  functions, and can ony be accessed if there are function getters or  */
  /*  modified through setters                                          */
  /*************************************************************************/
  var serverData;                 // JSON representation of data from server
  var rawJSONServerData;          // stores the JSON received from backend
  var unshiftedServerData;        // Unshifted version (if serverData shifted at all).

  var shiftPoint = { t: 0, y: 0 };// the shift point amount, where t holds the minute amount (horizontal), and 
  // y holds the y value shift amount wrt to the unshiftedData


  var resizeListener;             // reference to the function that listens for window resize to resize chart

  var ctx = canvasDOMElement ? canvasDOMElement.getContext('2d') : undefined;
  // holds reference to the canvas object on which chart is drawn
  var chart;                      // holds the Chart.JS chart object
  var chartOptions;               // JSON like struct of all options for chart
  var chartPlugins;               // Struct for holding plugins for this chart exclusively
  var userChartOptions = JSON.parse(JSON.stringify(options));
  // the passed in initializing chartOptions set by user
  var coordTooltip;               // container for showing the x and y coordinates on chart as mouse is dragged

  // DATES
  var referenceDate;              // what time is the reference timestamp for time axes
  var startDate;                  // startDate is the leftmost date displayed on chart
  var endDate;                    // endDate is the rightmost date displated on chart

  // CONSTANTS
  var POINT_RADIUS = 2.5;         // radius point for Chart
  var POINT_RADIUS_SELECTED = 4;
  var DATASET_INDEX = 0;          // which chart dataset index is the one that will be redrawn? if enabled
  var epsilonYGridline = 0.05     // this epsilon is used to subtract from the y min and max limits
  // since they are close to even/round numbers - and this screws up with 
  // the generation of ticks when you start to pan (refer to Notes for more info)
  // also see Chart.bundle.js line 17095

  // CUSTOM FUNCTIONS
  var CustomVerticalStepSize;     // custom function that can be defined by user for determining vertical 
                                  // step size. needs to take arguments (minValue, maxValue)
  var CustomHorizontalStepSize;   // custom function that can be defined by user for determining horizontal 
                                  // step size. needs to take arguments (minValue, maxValue)
  // FUNCTION arrays
  var AnnotationUpdateFunctions = [];
  // holds functions added by AddAnnotationUpdateFunction, that
  // take in arguments (chartData, annotationLines), so that
  // they can update them as per the caller requirements
  var AxesUpdateFunctions = [];   // same as above but for AxesUpdate. These functions get 
  // called after every axes update event
  var UpdateFunctions = [];       // generic update functions that need to execute during UpdateChart call

  /*************************************************************************/
  /* GETTER/SETTER FUNCTIONS                                            */
  /* Functions that allow outside caller to modify and or get the value of */
  /* private variables. Useful for when we are initailizing the chart      */
  /* or we want to change some options on the fly                       */
  /*************************************************************************/
  this.SetChartCanvas = function (canvasDOMElement) {
    ctx = canvasDOMElement.getContext('2d');
  }

  this.EnablePan = function (enable) {

    if (enable === true) {
      chartOptions.pan.enabled = true;
    } else {
      chartOptions.pan.enabled = false;
    }

    if (chart) {
      UpdateChart(false);
    }
  }

  this.EnableZoom = function (enable) {

    if (enable === true) {
      chartOptions.zoom.enabled = true;
    } else {
      chartOptions.zoom.enabled = false;
    }

    if (chart) {
      UpdateChart(false);
    }
  }

  this.EnableRedraw = function (enable, datasetIndex) {
    if (enable === true) {
      chartOptions.draw.enabled = true;
    } else {
      chartOptions.draw.enabled = false;
    }

    if (chart) {
      chartOptions.draw.datasetIndex = Math.max(0, Math.min(chart.data.datasets.length - 1, datasetIndex));
      UpdateChart(false);
    }
  }

  /*
   * Retrieves the current user chart options that have been set
   */
  this.GetUserChartOptions = function () {
    var currentUserChartOptions = new Options();
    var tempChartOptions = JSON.parse(JSON.stringify(chart.options))
    currentUserChartOptions.responsive = tempChartOptions.responsive
    currentUserChartOptions.maintainAspectRatio = tempChartOptions.maintainAspectRatio
    currentUserChartOptions.chartArea = tempChartOptions.chartArea
    currentUserChartOptions.title = tempChartOptions.title
    currentUserChartOptions.legend = {
      position: tempChartOptions.legend.position,
      display: tempChartOptions.legend.display,
    }
    currentUserChartOptions.layout = { ...tempChartOptions.layout };
    currentUserChartOptions.scales = {
      yAxes: [{
        marginTop: userChartOptions.scales.yAxes[0].marginTop,
        marginBottom: userChartOptions.scales.yAxes[0].marginBottom,
        stepFactor: userChartOptions.scales.yAxes[0].stepFactor,

        color: tempChartOptions.scales.yAxes[0].color,
        gridLines: tempChartOptions.scales.yAxes[0].gridLines,
        ticks: {
          max: tempChartOptions.scales.yAxes[0].ticks.max,
          min: tempChartOptions.scales.yAxes[0].ticks.min,
          stepSize: tempChartOptions.scales.yAxes[0].ticks.stepSize,
          fontColor: tempChartOptions.scales.yAxes[0].ticks.fontColor,
          fontSize: tempChartOptions.scales.yAxes[0].ticks.fontSize,
          fontFamily: tempChartOptions.scales.yAxes[0].ticks.fontFamily,
          beginAtZero: tempChartOptions.scales.yAxes[0].ticks.beginAtZero,
          minorToMajor: userChartOptions.scales.yAxes[0].ticks.minorToMajor,
          dynamicStepSize: userChartOptions.scales.yAxes[0].ticks.dynamicStepSize,
        },
        scaleLabel: tempChartOptions.scales.yAxes[0].scaleLabel,
      }],
      xAxes: [{
        color: tempChartOptions.scales.xAxes[0].color,
        type: tempChartOptions.scales.xAxes[0].type,
        scaleLabel: tempChartOptions.scales.xAxes[0].scaleLabel,
        ticks: {
          fontColor: tempChartOptions.scales.xAxes[0].ticks.fontColor,
          fontSize: tempChartOptions.scales.xAxes[0].ticks.fontSize,
          fontFamily: tempChartOptions.scales.xAxes[0].ticks.fontFamily,
          autoSkip: tempChartOptions.scales.xAxes[0].ticks.autoSkip,
          //callback: tempChartOptions.scales.xAxes[0].ticks.referenceHourEnabled ? GenerateTicksByReferenceHour : null,
          maxRotation: tempChartOptions.scales.xAxes[0].ticks.maxRotation,
          referenceHourEnabled: userChartOptions.scales.xAxes[0].ticks.referenceHourEnabled,
          minorToMajor: userChartOptions.scales.xAxes[0].ticks.minorToMajor
        },
        gridLines: tempChartOptions.scales.xAxes[0].gridLines,
        time: tempChartOptions.scales.xAxes[0].time,
        numUnitsToMinTime: userChartOptions.scales.xAxes[0].numUnitsToMinTime,
        numUnitsToMaxTime: userChartOptions.scales.xAxes[0].numUnitsToMaxTime,
      }]
    };
    currentUserChartOptions.draw = userChartOptions.draw;
    currentUserChartOptions.shift = userChartOptions.shift;
    currentUserChartOptions.zoom = tempChartOptions.zoom;
    currentUserChartOptions.pan = tempChartOptions.pan;
    currentUserChartOptions.plugins = userChartOptions.plugins;
    // give caller a copy of the userCharOptions - not the mutable object
    return currentUserChartOptions;
  }

  this.SetUserChartOptions = function (newChartOptions) {
    userChartOptions = JSON.parse(JSON.stringify(newChartOptions));
    InitializeChartOptions();
  }

  this.SetReferenceDate = function (refDate) {
    referenceDate = moment(refDate);
  }

  this.GetDatasetIndex = function () {
    return DATASET_INDEX;
  }

  this.GetTotalShift = function () {
    return shiftPoint;
  }

  this.GetData = function () {
    return serverData;
  }

  this.GetUnshiftedData = function () {
    return unshiftedServerData;
  }

  this.HighlightDataset = function (datasetId) {
    SetDatasetBorderWidth(datasetId, POINT_RADIUS_SELECTED)
  }

  this.UnhighlightDataset = function (datasetId) {
    SetDatasetBorderWidth(datasetId, POINT_RADIUS)
  }

  function SetDatasetBorderWidth(datasetId, chosenWidth) {
    var datasetIndex = -1;
    if (!chart.data.datasets) {
      return;
    }
    chart.data.datasets.forEach(
      function (dataset, index) {
        if (datasetId === serverData.ids[index]) {
          datasetIndex = index;
        }
        dataset.borderWidth = POINT_RADIUS;
      }
    )
    if (datasetIndex >= 0) {
      chart.data.datasets[datasetIndex].borderWidth = chosenWidth
      chart.update();
    }
  }

  function NumberDatasets() {
    if (serverData.datasets) {
      return serverData.datasets.length;
    }
  }

  /*
  * Initializing function that should be called when page is ready for charting
  */
  this.Initialize = function () {
    // register chart plugins
    InitializeChartPlugins();
    // init the chart options and draw it
    InitializeChart();
    // init the draw tooltip in case it's used
    InitializeDrawTooltip();
    // let's resize the the chart on window onresize event
    resizeListener = function (e) { chart.resize(); }
    window.addEventListener('resize', resizeListener);
  }

  /*************************************************************************************************/
  /************************* 1.0 SERVER RELATED FUNCTIONS ******************************************/
  /*************************************************************************************************/
  /*
  * Function revives dates from "/Date(15442342342)/" format to proper - uses moment.js library since
  * otherwise we might miss time zone information
  */
  var dateTimeReviver = function (key, value) {
    var a;
    if (typeof value === 'string') {
      a = /\/Date\((\d+)([-+])(\d+)\)\//.exec(value);
      if (a) {
        // new step - have to see what the date timezone is and compare it to this client timezone
        var serverTimezone = parseInt(a[3], 10) / 100;
        var clientTimezone = new Date().getTimezoneOffset() / 60;  // getTimezoneOffset will return hour zones client is offseet
        // from UTC (in minutes). Hence divide by 60 to get hours
        var timeToAdd = (clientTimezone - serverTimezone) * (3600 * 1000) // convert to milliseconds
        return new Date(parseInt(a[1], 10) + timeToAdd);
      }
      // else the time value will be like '2018-02-28-...' - just cast it to new Date
      // new Date results in much smaller memory footprint then moment (GJ, 30-07-2018)
      if (key === 't') {
        var convertedDate = new Date(value);
        return convertedDate;
      }
    }
    return value;
  }

  var CopyObject = function (obj) {
    var clone = {};
    for (var i in obj) {
      if (obj[i] != null && typeof (obj[i]) === "object")
        clone[i] = CopyObject(obj[i]);
      else
        clone[i] = obj[i];
    }
    return clone;
  }

  /*
  * Function handles the server data that comes back from Server.
  * if the call was for a partial update, then we just append the new data to the
  * serverData JSON structure. Otherwise we copy all of it to serverData
  */
  this.ConvertServerDataToChart = function (serverDataString) {
    rawJSONServerData = serverDataString;
    serverData = JSON.parse(rawJSONServerData, dateTimeReviver);
    unshiftedServerData = JSON.parse(rawJSONServerData, dateTimeReviver);
    UpdateChart(true, true, true);
  }

  this.SetChartData = function (objectData, updateAxis) {
    rawJSONServerData = JSON.stringify(objectData);
    serverData = JSON.parse(rawJSONServerData, dateTimeReviver);
    unshiftedServerData = JSON.parse(rawJSONServerData, dateTimeReviver);

    // throw out any dataset with no data inside it
    const validDatasetsIndices = $.map(serverData.datasets, function (dataset, a) { return dataset.data.length > 0 ? a : undefined })
    // fix for when ids is not supplied in the objectData!!!!
    serverData.ids = serverData.ids ? serverData.ids.filter(function (el, index) {
      return validDatasetsIndices.indexOf(index) > -1;
    }) : undefined;
    serverData.datasets = serverData.datasets.filter(function (el, index) {
      return validDatasetsIndices.indexOf(index) > -1;
    });


    if (updateAxis === undefined) {
      updateAxis = true;
    }
    UpdateChart(updateAxis, updateAxis, updateAxis);
  }

  /*************************************************************************************************/
  /*************************** 2.0 SHOW/HIDE FUNCTIONS ******************************************/
  /*************************************************************************************************/
  this.ShowDatasets = function (datasetsIndices) {
    // make sure datasetsIndices is valid array
    if (!datasetsIndices) {
      return;
    }
    if (datasetsIndices.length < 1) {
      return;
    }
    // go in loop and find which dataset needs to be unhidden
    for (var i in datasetsIndices) {
      if (parseInt(datasetsIndices[i], 10) >= 0 && parseInt(datasetsIndices[i], 10) < NumberDatasets()) {
        serverData.datasets[datasetsIndices[i]].hidden = 0;
        chart.data.datasets[datasetsIndices[i]].hidden = 0;
      }
    }
    // update chart 
    chart.update();
  }

  this.HideDatasets = function (datasetsIndices) {
    // make sure datasetsIndices is valid array
    if (!datasetsIndices) {
      return;
    }
    if (datasetsIndices.length < 1) {
      return;
    }
    // go in loop and find which dataset needs to be unhidden
    for (var i in datasetsIndices) {
      if (parseInt(datasetsIndices[i], 10) >= 0 && parseInt(datasetsIndices[i], 10) < NumberDatasets()) {
        serverData.datasets[datasetsIndices[i]].hidden = 1;
        chart.data.datasets[datasetsIndices[i]].hidden = 1;
      }
    }
    // update chart 
    chart.update();
  }

  // Gets the visible datasets indices by checking chart data
  this.GetVisibleDatasetsIndices = function(){
    if(chart){
      return chart.data.datasets
      .filter((d, index) => this.IsDatasetVisible(index))
      .map(x => chart.data.datasets.map(d => d.label).indexOf(x.label));
    }
    return [];
  }

  this.IsDatasetVisible = (index) => {
    const hiddenMeta = chart.getDatasetMeta(index).hidden;
    return hiddenMeta === null ? !chart.data.datasets[index].hidden : !hiddenMeta;
  }

  /*************************************************************************************************/
  /*************************************************************************************************/


  /*************************************************************************************************/
  /************************* 3.0 CHART PLOTTING FUNCTIONS ******************************************/
  /*************************************************************************************************/

  this.UpdateChart = function (resizeAxis) {
    var resizeVerticalAxis = resizeAxis;
    var resizeHorizontalAxis = resizeAxis
    UpdateChart(resizeAxis, resizeVerticalAxis, resizeHorizontalAxis);
  }

  this.UpdateChartOptions = function () {
    chart.update();
  }

  /*
  * Function gets the horizontal axis bounds (min and max)
  */
  this.GetHorizontalAxisLimits = function () {
    return {
      'min': moment(chart.options.scales.xAxes[0].time.min),
      'max': moment(chart.options.scales.xAxes[0].time.max)
    };
  }

  /*
  * Function allowing user to update the horizontal axis limits by specifying either, or all 
  * lower and upper bounds (in date) and whether to resize the vertical axis
  * 
  */
  this.UpdateHorizontalAxis = function (minTime, maxTime, resizeVerticalAxis) {
    var minDate;
    var maxDate;

    if (minTime) {
      minDate = moment(minTime);
      if (minDate.isValid()) {
        chartOptions.scales.xAxes[0].time.min = minDate;
      }
    }

    if (maxTime) {
      maxDate = moment(maxTime);
      if (maxDate.isValid() && maxDate > minDate) {
        chartOptions.scales.xAxes[0].time.max = maxDate;
      }
    }

    UpdateChart(true, resizeVerticalAxis, false);
  }

  /*
  * Function that gets called once new data has been received from server
  * and needs to be plotted on chart. The function works for full replot calls
  * or just partial updates since it just recreates the chart and performs
  * axis resizing as needed
  */
  function UpdateChart(resizeAxis, resizeVerticalAxis, resizeHorizontalAxis) {

    if (resizeAxis) {
      if (resizeHorizontalAxis) ResizeHorizontalAxis();
      if (resizeVerticalAxis) ResizeVerticalAxis(!resizeHorizontalAxis);
      // Run whatever Axes update functions need to execute now
      ExecuteAxesUpdateFunctions();
      chart.options.scales = chartOptions.scales;
    } else {
      // if not resizing axis, save the limits of the current chart in chartOptions so that we can redraw it
      // without affecting its limits.
      chartOptions.scales.yAxes[0].ticks.min = chart.options.scales.yAxes[0].ticks.min;
      chartOptions.scales.yAxes[0].ticks.max = chart.options.scales.yAxes[0].ticks.max;
      chartOptions.scales.xAxes[0].time.min = moment(chart.options.scales.xAxes[0].time.min).toDate();
      chartOptions.scales.xAxes[0].time.max = moment(chart.options.scales.xAxes[0].time.max).toDate();
    }
    UpdateAnnotations();

    // if there are any generic update functions that need to execute
    // before the chart is redrawn
    ExecuteUpdateFunctions();

    if (!serverData) {
      return;
    }

    // UPDATED DATA 
    chart.config.data = UpdateDataForChart();
    // UPDATED OPTIONS
    // For changed options we need to update them by mutating chart.options in place
    chart.options.scales.xAxes[0].time.min = moment(chartOptions.scales.xAxes[0].time.min).toDate();
    chart.options.scales.xAxes[0].time.max = moment(chartOptions.scales.xAxes[0].time.max).toDate();
    chart.options.scales.yAxes[0].ticks.min = chartOptions.scales.yAxes[0].ticks.min;
    chart.options.scales.yAxes[0].ticks.max = chartOptions.scales.yAxes[0].ticks.max;
    chart.options.scales.xAxes[0].time.unitStepSize = chartOptions.scales.xAxes[0].time.unitStepSize;
    chart.options.title = chartOptions.title;
    chart.options.annotation.annotations = chartOptions.annotation.annotations;

    // Force an update on the chart since we changed data and options 
    chart.update();

  }

  /*
  * Function relies on serverData to construct datasets for chart
  * and returns this array of datasets to caller
  */
  function UpdateDataForChart() {
    var alldata = {};
    alldata.datasets = [];
    alldata.labels = [];

    if (!serverData) {
      return alldata;
    }

    const invalidValue = userChartOptions.scales.yAxes[0].invalidValue;

    serverData.datasets.forEach(function (serverDataset, _index) {
      var dataset = {}
      dataset.hidden = serverDataset.hidden;
      dataset.label = serverDataset.label;
      // how long is each time step in this dataset - so we know how to fill apparent time gaps
      const datasetTimeStep = serverDataset.timeStep
      var data = [];
      serverDataset.data.forEach(function (point, index, dataServer) {
        if (index !== 0) {
          var prevStepTime = new moment(data[data.length - 1].t);
          var currStepTime = new moment(point.t);
          // fill up any missing minute data with null so that chart recognizes and leaves gap in line
          while (currStepTime.diff(prevStepTime, "minutes") > datasetTimeStep) {
            // add timeStep minute null data for this dataseet
            prevStepTime.add(datasetTimeStep, "minutes");
            data.push({ t: prevStepTime.toDate(), y: null });
          }
        }
        if (point.y === invalidValue) {
          // push the data value of null - we don't want to plot zeros
          data.push({ t: point.t, y: null });
        } else {
          // push the data value to this temp object data
          data.push(point);
        }
      });
      // if there are no data points in the server dataset then let's return and not create this object
      if(data.length < 1) return;

      dataset.data = data;

      // update the colour for this dataset point - since selectedPoints contain the
      // data in same order
      dataset.borderColor = serverDataset.lineColour;//DatasetColour(i);
      dataset.backgroundColor = serverDataset.backgroundColour;
      dataset.pointBackgroundColor = serverDataset.pointColour;
      dataset.pointBorderColor = serverDataset.pointColour;
      dataset.fill = false;            // don't want area under graph to be filled

      dataset.borderDash = serverDataset.borderDash;

      dataset.pointStyle = serverDataset.pointStyle;
      // line width default
      dataset.borderWidth = serverDataset.borderWidth;
      dataset.pointBorderWidth = serverDataset.pointBorderWidth;
      dataset.pointHoverRadius = serverDataset.pointHoverRadius;
      // dataset.pointHoverBorderWidth = 1;
      dataset.pointRadius = serverDataset.pointRadius;
      dataset.pointHitRadius = serverDataset.pointHitRadius;      // set to non zero so that hover event can be captured

      // push the dataset for this point to the
      alldata.datasets.push(dataset);
    });
    return alldata;
  }

  /*
  * Function looks at serverData and its dataset to determine
  * the maximum value.
  */
  var FindMaxYValue = function (minTime, maxTime) {
    var firstValue;
    var maxValue = 0;
    var dataMaxTime;
    var dataMinTime;
    if (!serverData) {
      // need to get default limits when no data selected
      return 1000;
    }
    firstValue = true;
    serverData.datasets.forEach(function (dataset, index, datasets) {
      if (!maxTime) {
        dataMaxTime = dataset.data[dataset.data.length - 1].t
      } else {
        dataMaxTime = maxTime
      }
      if (!minTime) {
        dataMinTime = dataset.data[0].t
      } else {
        dataMinTime = minTime
      }


      dataset.data.forEach(function (point, index, data) {
        if (dataMinTime <= point.t &&
          dataMaxTime >= point.t &&
          (firstValue || maxValue < point.y)) {
          if (firstValue) {
            firstValue = false;
          }
          maxValue = point.y;
        }
      });
    });
    return maxValue;
  }

  /*
  * Function looks at serverData and its dataset to determine
  * the minimum value.
  */
  var FindMinYValue = function (minTime, maxTime) {
    var minValue = 0;
    var firstValue;
    var dataMaxTime;
    var dataMinTime;

    if (!serverData) {
      // need to get default limits when no data selected
      return 0;
    }
    firstValue = true;
    const invalidValue = userChartOptions.scales.yAxes[0].invalidValue;

    serverData.datasets.forEach(function (dataset, index, datasets) {
      if (dataset.data.length < 1) return;

      if (!maxTime) {
        dataMaxTime = dataset.data[dataset.data.length - 1].t
      } else {
        dataMaxTime = maxTime
      }
      if (!minTime) {
        dataMinTime = dataset.data[0].t
      } else {
        dataMinTime = minTime
      }

      dataset.data.forEach(function (point, index, data) {
        if (point.y === invalidValue) {
          return;
        }

        if (dataMinTime <= point.t &&
          dataMaxTime >= point.t &&
          (firstValue || minValue > point.y)) {
          if (firstValue) {
            firstValue = false;
          }
          minValue = point.y;
        }
      });
    });

    return minValue;
  }

  function CalculateVerticalStepSize(minValue, maxValue) {
    var delta = RoundNumberTo((maxValue - minValue) / 8.0, 2);

    var r = delta - Math.floor(delta)

    if (r <= 0.05) {
      delta = Math.floor(delta) + 0.05
    } else if (r <= 0.20) {
      delta = Math.floor(delta) + 0.10
    } else if (r <= 0.50) {
      delta = Math.floor(delta) + 0.50
    } else {
      delta = Math.floor(delta) + 1.00
    }

    return delta;
  }

  function CalculateVerticalAxisBounds(isHorizontalAxisFixed) {
    var minTime;
    var maxTime;
    // find the index of time between which we need to search for min and max values
    if (isHorizontalAxisFixed) {
      minTime = chartOptions.scales.xAxes[0].time.min;
      maxTime = chartOptions.scales.xAxes[0].time.max;
    }

    // pass those bounds to functions below

    // get the maximum and minimum values for all columns
    var minValue = RoundNumberTo(FindMinYValue(minTime, maxTime), 2);
    var maxValue = RoundNumberTo(FindMaxYValue(minTime, maxTime), 2);

    var maxValueToNearestPreferredStepSize = Math.round(maxValue / userChartOptions.scales.yAxes[0].stepFactor) * userChartOptions.scales.yAxes[0].stepFactor;
    var minValueToNearestPreferredStepSize = Math.round(minValue / userChartOptions.scales.yAxes[0].stepFactor) * userChartOptions.scales.yAxes[0].stepFactor;

    // trick for getting the next closest value that is 0.05, 0.1, etc.
    if (maxValueToNearestPreferredStepSize - maxValue > 0) {
      maxValue = maxValueToNearestPreferredStepSize;
      //if(maxValueStr.substr(maxValueStr.length-1) != "5" && maxValueStr.substr(maxValueStr.length-1) != "0"){
      maxValue = Math.ceil((maxValue) / userChartOptions.scales.yAxes[0].marginTop) * userChartOptions.scales.yAxes[0].marginTop + userChartOptions.scales.yAxes[0].marginTop;
    } else {
      maxValue = maxValueToNearestPreferredStepSize + userChartOptions.scales.yAxes[0].marginTop;
    }
    if (minValue - minValueToNearestPreferredStepSize > 0) {
      minValue = Math.floor((minValue) / userChartOptions.scales.yAxes[0].marginBottom) * userChartOptions.scales.yAxes[0].marginBottom - userChartOptions.scales.yAxes[0].marginBottom;
    } else {
      minValue = minValue - userChartOptions.scales.yAxes[0].marginBottom;
    }


    return { 'min': parseFloat(minValue), 'max': parseFloat(maxValue) }
  }

  /*
  * Resize the vertical axis of the chart. Look at the max and min values
  * that need to be graphed. Get axis bounds by rounding both of these
  * to next closest .05 value
  */
  function ResizeVerticalAxis(isHorizontalAxisFixed) {
    var bounds = CalculateVerticalAxisBounds(isHorizontalAxisFixed);
    bounds.min = RoundNumberTo(bounds.min, 3);
    bounds.max = RoundNumberTo(bounds.max, 3)

    // if dynamicStepSize is enabled then calculate step size - otherwise don't touch it
    if (userChartOptions.scales.yAxes[0].ticks.dynamicStepSize) {
      var stepSize = CustomVerticalStepSize ?
        CustomVerticalStepSize(bounds.min, bounds.max) :
        CalculateVerticalStepSize(bounds.min, bounds.max);
      chartOptions.scales.yAxes[0].ticks.stepSize = parseFloat((stepSize / userChartOptions.scales.yAxes[0].ticks.minorToMajor).toFixed(2));
    }

    // subtract and add small amount to min and max (% of step size)
    chartOptions.scales.yAxes[0].ticks.min = parseFloat(bounds.min - chartOptions.scales.yAxes[0].ticks.stepSize * epsilonYGridline);
    chartOptions.scales.yAxes[0].ticks.max = parseFloat(bounds.max + chartOptions.scales.yAxes[0].ticks.stepSize * epsilonYGridline);

  }



  /*
  * Function gets the start date from the serverData by looking at the earliest date out of 
  * all datasets
  */
  function GetStartDateFromData() {
    var sDate;

    if (serverData.datasets == null) {
      sDate = new moment();
      sDate.subtract(24, "h");
      return sDate;
    }

    sDate = new moment(serverData.datasets[0].data[0].t)

    for (var i = 0; i < NumberDatasets(); i++) {
      if (serverData.datasets[i].data.length > 0) {
        if (sDate > moment(serverData.datasets[i].data[0].t)) {
          sDate = moment(serverData.datasets[i].data[0].t);
        }
      }
    }
    return sDate;
  }

  /*
  * Function gets the start date from the serverData by looking at the latest date out of 
  * all datasets
  */
  function GetEndDateFromData() {
    var eDate;

    if (serverData.datasets == null) {
      eDate = new moment();
      return eDate;
    }

    eDate = moment(serverData.datasets[0].data[serverData.datasets[0].data.length - 1].t)

    for (var i = 0; i < NumberDatasets(); i++) {
      if (serverData.datasets[i].data.length > 0) {
        if (eDate === undefined) {
          eDate = moment(serverData.datasets[i].data[serverData.datasets[0].data.length - 1].t)
        }
        if (eDate < moment(serverData.datasets[i].data[serverData.datasets[i].data.length - 1].t)) {
          eDate = moment(serverData.datasets[i].data[serverData.datasets[i].data.length - 1].t);
        }
      }
    }

    return eDate;
  }

  /*
  * Resize the vertical axis of the chart. Look at the max and min values
  * that need to be graphed. Get axis bounds by rounding both of these
  * to next closest .05 value
  */
  function ResizeHorizontalAxis() {
    // get the maximum and minimum values for all columns
    if (!serverData) {
      // need to get default limits when no data selected
      return;
    }

    startDate = GetStartDateFromData();
    endDate = GetEndDateFromData();

    var dates = [];
    var unitsFactorToHour = GetTimeUnitHours();

    if (referenceDate) {
      dates[0] = new moment(referenceDate);
    } else {
      dates[0] = new moment(startDate);
    }
    dates[0].hours(dates[0].hours() - unitsFactorToHour * userChartOptions.scales.xAxes[0].numUnitsToMinTime * userChartOptions.scales.xAxes[0].time.unitStepSize);
    // set beginning of time axis numUnitsToMinTime before reference start time
    dates[0].minutes(0);
    dates[0].seconds(0);

    dates[1] = new moment(endDate);
    dates[1] = dates[1].hours(dates[1].hours() + unitsFactorToHour * userChartOptions.scales.xAxes[0].numUnitsToMaxTime * userChartOptions.scales.xAxes[0].time.unitStepSize);   // set end of time axis to 12 hours past the last forecast data point

    chartOptions.scales.xAxes[0].time.min = dates[0];
    chartOptions.scales.xAxes[0].time.max = dates[1];

    if(userChartOptions.scales.xAxes[0].ticks.dynamicStepSize){
      var minValue = dates[0];
      var maxValue = dates[1];
      var stepSize = CustomHorizontalStepSize ?
        CustomHorizontalStepSize(minValue, maxValue, chartOptions.scales.xAxes[0].ticks) :
        chartOptions.scales.xAxes[0].time.unitStepSize * userChartOptions.scales.xAxes[0].ticks.minorToMajor;

      chartOptions.scales.xAxes[0].time.unitStepSize = parseFloat((stepSize / userChartOptions.scales.xAxes[0].ticks.minorToMajor).toFixed(2));
    }
  }
  /*************************************************************************************************/
  /*************************************************************************************************/


  /*************************************************************************************************/
  /************************* 3.0 REDRAW SERIES FUNCTIONS *******************************************/
  /*************************************************************************************************/

  /* 
  * Function responsible for initiating the dragging events once user mouse presses onto the chart
  * It ensures chart options allow for this functionality 
  */
  var StartDrawingLine = function (event) {
    if (chart.data.datasets.length < chart.options.draw.datasetIndex + 1 || !chart.options.draw.enabled) {
      return;
    }
    chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints = [];

    var DrawingLineFunction = chart.options.draw.drawingLineFunction;

    DrawingLineFunction(event);

    $(chart.canvas.parentNode).off("mousedown");
    $(chart.canvas.parentNode).off("mousemove").on("mousemove", DrawingLineFunction);
    $(chart.canvas.parentNode).off("mouseup").on("mouseup", StopDrawingLine);
  }

  /* 
  * Function responsible for initiating the dragging events once user mouse presses onto the chart
  * It ensures chart options allow for this functionality
  */
  var StartShiftingLine = function (event) {

    if (chart.data.datasets.length < chart.options.draw.datasetIndex + 1 || !chart.options.shift.enabled) {
      return;
    }

    var newPoint = CalculatePoint(event);
    if (!newPoint) {
      StopShiftingLine(event);
      return;
    }

    chart.data.datasets[chart.options.shift.datasetIndex].startShiftPoint = newPoint;

    var ShiftingLineFunction = chart.options.shift.shiftingLineFunction;

    $(chart.canvas.parentNode).off("mousedown");
    $(chart.canvas.parentNode).off("mousemove").on("mousemove", ShiftingLineFunction);
    $(chart.canvas.parentNode).off("mouseup").on("mouseup", StopShiftingLine);
  }

  /*
  * Helper function responsible for redrawing the points currently drawn by user
  * onto the chart's canvas - this is needed in case chart gets redrawn while user
  * is still dragging.
  */
  var RedrawPoints = function (chart) {
    if (!chart) {
      return;
    }
    if (chart.data.datasets.length < chart.options.draw.datasetIndex + 1) {
      return;
    }
    var drawnPoints = chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints;

    if (!drawnPoints) {
      return;
    }

    for (var i = 1; i < drawnPoints.length; i++) {
      chart.options.draw.drawPointFunction(drawnPoints[i - 1], drawnPoints[i]);
    }
  }

  /*
  * Function draws a line between two points
  */
  var DrawPoint = function (prevPoint, currPoint) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(prevPoint.x, prevPoint.y);
    ctx.lineTo(currPoint.x, currPoint.y);
    ctx.strokeStyle = chart.options.draw.color;
    ctx.lineWidth = chart.options.draw.thickness;
    ctx.stroke();
    ctx.closePath();
    ctx.restore();
  }

  /*
  * Function converts Y coordinate of a given point to actual y value corresponding to point on 
  * chart (i.e. elevation)
  */
  var ConvertPointToYCoord = function (point) {
    var yCoord = chart.chartArea.bottom - point.y;
    var range = chart.options.scales.yAxes[0].ticks.max - chart.options.scales.yAxes[0].ticks.min
    var yPoint = yCoord / (chart.chartArea.bottom - chart.chartArea.top) * range + parseFloat(chart.options.scales.yAxes[0].ticks.min);
    return yPoint;
  }

  /*
  * Function converts X coordinate of a given point to the index value of a point closest to it 
  * on the chart (i.e. time)
  * Return value: integer value
  */
  var ConvertPointToXIndex = function (point) {
    var xCoord = point.x - chart.chartArea.left;

    var minTime = moment(chart.options.scales.xAxes[0].time.min);
    var maxTime = moment(chart.options.scales.xAxes[0].time.max);
    var startTime = serverData.datasets[chart.options.draw.datasetIndex].data[0].t
    var timeRange = maxTime.valueOf() - minTime.valueOf();
    var timePoint = parseInt(xCoord / (chart.chartArea.right - chart.chartArea.left) * timeRange - (startTime.valueOf() - minTime.valueOf()), 10);
    var timeStep = serverData.datasets[chart.options.draw.datasetIndex].timeStep;        // the time step of the dataset index of interest in minutes
    return parseInt(Math.round(timePoint / 60 / 1000 / timeStep), 10);
  }

  /*
  * Converts a point X coordinate to hours difference between the time it represents
  * on the chart and the reference hour (i.e. forecast start time)
  */
  var ConvertPointToXHours = function (point) {
    var xCoord = point.x - chart.chartArea.left;

    var minTime = moment(chart.options.scales.xAxes[0].time.min);
    var maxTime = moment(chart.options.scales.xAxes[0].time.max);
    var timeRange = maxTime.valueOf() - minTime.valueOf();
    var timePoint = parseInt(xCoord / (chart.chartArea.right - chart.chartArea.left) * timeRange + minTime.valueOf(), 10)

    var referenceHour = chart.data.datasets[chart.options.draw.datasetIndex].data[0].t;
    var pointHour = moment(timePoint);

    var hourDifference = parseFloat(pointHour.diff(referenceHour, "minutes") / 60);
    return hourDifference;
  }


  var ShiftingLineFunction = function (e) {
    var newPoint = CalculatePoint(e);
    if (!newPoint) {
      return;
    }

    chart.data.datasets[chart.options.shift.datasetIndex].endShiftPoint = newPoint;
  }

  /*
  * Calculate the point that needs to be drawn onto the chart's canvas. Also
  * calculate the time, elevation value it represents and show it on tooltip
  */
  var DrawingLineFunction = function (e) {
    var points = chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints;
    var newPoint = CalculatePoint(e);
    if (!newPoint) {
      return;
    }

    if (points.length > 1) {
      var prevPoint = points.slice(points.length - 1)[0];
      chart.options.draw.drawPointFunction(prevPoint, newPoint);
    }
    chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints.push(newPoint);

    UpdatePointTooltip(e, newPoint);
  }

  var UpdatePointTooltip = function (e, newPoint) {
    var hourDifference = ConvertPointToXHours(newPoint);
    coordTooltip.show();
    coordTooltip.css("left", e.pageX + 10);
    coordTooltip.css("top", e.pageY - 20);
    coordTooltip.html(hourDifference.toFixed(2) + " , " + RoundNumberTo(ConvertPointToYCoord(newPoint), 2).toFixed(2));
  }

  /*
  * Calculate the point that needs to be drawn onto the chart's canvas. Also
  * calculate the time, elevation value it represents and show it on tooltip
  */
  var CalculatePoint = function (e) {
    var newPoint;
    newPoint = { x: e.pageX - chart.canvas.offsetLeft, y: e.pageY - chart.canvas.offsetTop };
    if (newPoint.x < chart.chartArea.left || newPoint.x > chart.chartArea.right || newPoint.y < chart.chartArea.top || newPoint.y > chart.chartArea.bottom) {
      return;
    } else {
      return newPoint;
    }
  }


  var StopShiftingLine = function (event) {
    $(event.target.parentNode).off("mousemove");
    $(event.target.parentNode).off("mouseup");
    ShiftChartPoints();
  }

  /*
  * Event function gets executed when user lets go of drag action on chart. Hide the tooltip
  * and initiate the movement of chart points
  */
  var StopDrawingLine = function (event) {
    $(event.target.parentNode).off("mousemove");
    $(event.target.parentNode).off("mouseup");
    coordTooltip.hide();
    MoveChartPoints();
  }

  /* This function is responsible for moving the affected data points from the chosen chart's dataset series, that
  * fall in the x-range of the drawn points for that same dataset. It takes the pixel values of each point,
  * converts them to actual y value (e.g. flow, elevation) and the correct time step index based on the chart's
  * axis limits. The end result is the global array that holds the dataset data modified. The function then
  * calls the UpdateChart function to get the chart redrawn, thus showing the modified points
  */
  var MoveChartPoints = function () {
    // ensure there is points to draw before going further
    if (!serverData) {
      return;
    }
    var timeIndex;
    var elevationValue;

    if (chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints.length < 1) {
      return;
    }

    var stepSize = serverData.datasets[chart.options.draw.datasetIndex].timeStep;

    var prevTimeIndex = ConvertPointToXIndex(chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints[0]);
    var timeDirection = 1;
    var interpolatedTimeIndex = timeIndex;
    var interpolatedElevationSlope;
    var interpolatedElevationValue;
    var shiftOffsetIndex = shiftPoint.t > 0 ? shiftPoint.t / stepSize : 0;
    for (var i = 0; i < chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints.length; i++) {
      timeIndex = ConvertPointToXIndex(chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints[i]);
      elevationValue = ConvertPointToYCoord(chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints[i]);
      if (i > 0)
        interpolatedElevationSlope = (elevationValue - ConvertPointToYCoord(chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints[i - 1])) / (timeIndex - prevTimeIndex);

      interpolatedTimeIndex = prevTimeIndex;
      if (timeIndex - interpolatedTimeIndex > 0) {
        timeDirection = 1;
      } else {
        timeDirection = -1;
      }
      // fill in any missing data points for time steps between this current point and last point
      while (Math.abs(timeIndex - interpolatedTimeIndex) > 1) {
        interpolatedTimeIndex = interpolatedTimeIndex + timeDirection;
        if (interpolatedTimeIndex >= 0 && interpolatedTimeIndex < serverData.datasets[chart.options.draw.datasetIndex].data.length) {
          interpolatedElevationValue = ConvertPointToYCoord(chart.data.datasets[chart.options.draw.datasetIndex].drawnPoints[i - 1]) + interpolatedElevationSlope * (interpolatedTimeIndex - prevTimeIndex);
          serverData.datasets[chart.options.draw.datasetIndex].data[interpolatedTimeIndex].y = interpolatedElevationValue;
          // update the unshifted version of the data since user decided to redraw parts of it                
          if (interpolatedTimeIndex - shiftOffsetIndex >= 0 && interpolatedTimeIndex < unshiftedServerData.datasets[chart.options.draw.datasetIndex].data.length) {
            unshiftedServerData.datasets[chart.options.draw.datasetIndex].data[interpolatedTimeIndex - shiftOffsetIndex].y = interpolatedElevationValue;
          }

        }
      }
      if (timeIndex >= 0 && timeIndex < serverData.datasets[chart.options.draw.datasetIndex].data.length) {
        serverData.datasets[chart.options.draw.datasetIndex].data[timeIndex].y = elevationValue;
        // update the unshifted version of the data since user decided to redraw parts of it
        if (timeIndex - shiftOffsetIndex >= 0 && timeIndex < unshiftedServerData.datasets[chart.options.draw.datasetIndex].data.length) {
          unshiftedServerData.datasets[chart.options.draw.datasetIndex].data[timeIndex - shiftOffsetIndex].y = elevationValue;
        }
      }

      prevTimeIndex = timeIndex;
    }
    UpdateChart(false);
  }

  /* This function is responsible for shifting the chosen dataset by the amount of distance dragged by 
  * user. The total net amount of shift that the user has made is stored in shiftPoint, which then
  * is added to the unshifted version of the dataset's data and the result is stored in serverData which is 
  * used for plotting purposes. Also, the data gap that might exist between the start time and shifted data
  * or end forecast time and end shifted data time, is filled by the closest (first, or last) value to that 
  * data gap. Finally UpdateChart is called without resizing.
  */
  var ShiftChartPoints = function () {
    var startPoint = chart.data.datasets[chart.options.shift.datasetIndex].startShiftPoint
    var endPoint = chart.data.datasets[chart.options.shift.datasetIndex].endShiftPoint;

    if (!startPoint || !endPoint) {
      return;
    }

    // ensure there is points to draw before going further
    if (!serverData) {
      return;
    }

    // 1 - Calculate the shift in time and in y-values
    var stepSize = serverData.datasets[chart.options.shift.datasetIndex].timeStep;
    var numStepsInHour = 60 / stepSize;

    // figure out the time shift in minutes rounded to timeStep minute interval, and add it to the total shift so far
    // since we will be shifting based on the unshifted data set.
    // also calculate the Y shift, if any and store it in shiftPoint.y; NB: we don't keep track of 
    // previous y shifts unlike the time shift, since we will update unshiftedServerData y value every time we
    // shift in y direct (if mode enabled).        
    shiftPoint.t = shiftPoint.t = shiftPoint.t + parseFloat(parseInt((ConvertPointToXHours(endPoint) - ConvertPointToXHours(startPoint)) * numStepsInHour, 10) * 60 / numStepsInHour);
    shiftPoint.y = ConvertPointToYCoord(endPoint) - ConvertPointToYCoord(startPoint)

    // reset the dataset series that we want to shift
    serverData.datasets[chart.options.shift.datasetIndex].data = []

    // use the unshifted version of that dataset series, and shift it by the net time shift
    for (var i = 0; i < unshiftedServerData.datasets[chart.options.shift.datasetIndex].data.length; i++) {
      serverData.datasets[chart.options.shift.datasetIndex].data.push({ t: 0, y: 0 });
      serverData.datasets[chart.options.shift.datasetIndex].data[i].t = moment(unshiftedServerData.datasets[chart.options.shift.datasetIndex].data[i].t);
      serverData.datasets[chart.options.shift.datasetIndex].data[i].y = unshiftedServerData.datasets[chart.options.shift.datasetIndex].data[i].y;

      if (chart.options.shift.mode.indexOf("x") >= 0) {
        serverData.datasets[chart.options.shift.datasetIndex].data[i].t = moment(serverData.datasets[chart.options.shift.datasetIndex].data[i].t).add(shiftPoint.t, "m");
      }
      if (chart.options.shift.mode.indexOf("y") >= 0) {
        serverData.datasets[chart.options.shift.datasetIndex].data[i].y += shiftPoint.y;
        // unlike time shift, for y shift, we update the unshiftedServerData value
        unshiftedServerData.datasets[chart.options.shift.datasetIndex].data[i].y += shiftPoint.y;
      }
    }

    if (chart.options.shift.mode.indexOf("x") < 0) {
      shiftPoint.t = 0;
    }
    if (~chart.options.shift.mode.indexOf("y") < 0) {
      shiftPoint.y = 0;
    }

    // fill in the data gap that will exist, either from left or right side
    FillInDataGap();

    // ready for replotting - let's plot data without resizing of axis
    UpdateChart(false);
  }

  /*
  * Function fills in the data gap between (if preseent) the forecast Start time and the start time of the 
  * shifted dataset, or the forecast end time and the end time of the shifted dataset (i.e. was shifted left) 
  */
  var FillInDataGap = function () {
    var len = serverData.datasets[chart.options.draw.datasetIndex].data.length;
    var unshiftedLen = unshiftedServerData.datasets[chart.options.draw.datasetIndex].data.length;
    var timeStep = serverData.datasets[chart.options.draw.datasetIndex].timeStep;

    if (!len || !unshiftedLen) {
      return;
    }

    // means we have shifted the graph to the right...add points to beginning of series
    while (serverData.datasets[chart.options.draw.datasetIndex].data[0].t > unshiftedServerData.datasets[chart.options.draw.datasetIndex].data[0].t) {
      serverData.datasets[chart.options.draw.datasetIndex].data.unshift({ t: moment(serverData.datasets[chart.options.draw.datasetIndex].data[0].t).add(-timeStep, "m"), y: serverData.datasets[chart.options.draw.datasetIndex].data[0].y });
      //serverData.datasets[chart.options.draw.datasetIndex].data.pop();            // keep removing the last point in data series, since it would be in future
    }

    // means we have shifted the graph to the left...add points to the end of series
    while (serverData.datasets[chart.options.draw.datasetIndex].data[len - 1].t < unshiftedServerData.datasets[chart.options.draw.datasetIndex].data[unshiftedLen - 1].t) {
      serverData.datasets[chart.options.draw.datasetIndex].data.push({ t: moment(serverData.datasets[chart.options.draw.datasetIndex].data[len - 1].t).add(timeStep, "m"), y: serverData.datasets[chart.options.draw.datasetIndex].data[len - 1].y });
      //serverData.datasets[chart.options.draw.datasetIndex].data.shift();          // remove the first point in data series, since it would be before referenceDate
      len = serverData.datasets[chart.options.draw.datasetIndex].data.length;
    }
  }
  /*************************************************************************************************/
  /*************************************************************************************************/


  /*************************************************************************************************/
  /************************* 4.0 INITIALIZING CHART FUNCTIONS **************************************/
  /*************************************************************************************************/

  var InitializeChart = function () {
    // 1. Get Chart Options initialized, based on userChartOptions
    InitializeChartOptions();

    // ths shifts are zero 
    shiftPoint.t = 0;
    shiftPoint.y = 0;

    var endTime = new Date();
    var startTime = new Date();

    // generic time window depending on currentTime
    startTime.setHours(startTime.getHours() - userChartOptions.scales.xAxes[0].numUnitsToMinTime);
    endTime.setHours(endTime.getHours() + userChartOptions.scales.xAxes[0].numUnitsToMaxTime);

    chartOptions.scales.xAxes[0].time.min = startTime;
    chartOptions.scales.xAxes[0].time.max = endTime;

    if (chart != null) {
      chart.destroy();
    }

    // only need to do this once
    chart = new ChartJS(ctx, {
      type: 'line',
      data: [],
      options: chartOptions,
      plugins: chartPlugins,
    });
  }



  function InitializeChartOptions() {
    // Function template for generting time ticks with 
    var LabelGeneratorX = function () {
      var generator = userChartOptions.scales.xAxes[0].ticks.referenceHourEnabled ? GenerateXGridlinesByReferenceHour : GenerateXGridlinesByDefault
      return generator;
    }

    var GenerateXGridlinesByReferenceHour = function (tickDate) {
      var timeOfTick = moment(tickDate);
      var hourDiff = timeOfTick.diff(referenceDate, "hours");
      return hourDiff;
    }

    var GenerateXGridlinesByDefault = function (tickDate) {
      return moment(tickDate).format(userChartOptions.scales.xAxes[0].time.displayFormats[userChartOptions.scales.xAxes[0].time.unit]);
    }

    /*
     * Function replaces the default generated ticks for x axis
     * by making sure they align with a reference date
     */
    var GenerateXTicks = function (scale) {
      if (!chart || !scale) return;
      if (scale._ticks.length < 1) return;

      var ticks = [];
      const labelGenerator = LabelGeneratorX();

      const minTime = moment(chart.options.scales.xAxes[0].time.min);
      const maxTime = moment(chart.options.scales.xAxes[0].time.max);
      const fixedDate = referenceDate ? moment(referenceDate) : moment(startDate);

      const firstTickTime = moment(scale._ticks[0].value);
      const diffReferenceToFirst = moment(fixedDate).diff(firstTickTime, "hours", true);

      //var deltaTimeToReferenceDate = moment(referenceDate).diff(firstLabelTime, "hours", true);
      const unitFactorToHour = GetTimeUnitHours();
      const totalUnitTimeDifference = diffReferenceToFirst / unitFactorToHour;
      const unitStepSize = chart.options.scales.xAxes[0].time.unitStepSize;
      const numHoursOffset = totalUnitTimeDifference % unitStepSize;
      const minorToMajor = userChartOptions.scales.xAxes[0].ticks.minorToMajor;

      // if the first label has no offset from referenceDate then we are good
      if (numHoursOffset === 0) {
        // since no offset, still update the labels by removing labels from minor gridlines
        const firstMajorIndex = 
          (totalUnitTimeDifference % (unitStepSize * minorToMajor) / unitStepSize + minorToMajor) % minorToMajor;
        // Math.abs((totalUnitTimeDifference % (unitStepSize * minorToMajor)) / unitStepSize);
        scale._ticks.forEach(tick => { tick.label = "" });
        for (var i = firstMajorIndex; i < scale._ticks.length; i += minorToMajor) {
          scale._ticks[i].label = labelGenerator(moment(scale._ticks[i].value));
        }
        return;
      }

      var diffMinToReference = moment(minTime).diff(fixedDate, "hours", true);
      var numStepsToMinTime = parseInt((diffMinToReference / unitFactorToHour) / unitStepSize, 10);
      var firstTime;

      if (numStepsToMinTime <= 0) {
        firstTime = moment(fixedDate).add(numStepsToMinTime * unitStepSize, "h");
      } else {
        firstTime = moment(fixedDate).add((numStepsToMinTime + 1) * unitStepSize, "h");
      }


      for (var newTick = firstTime; newTick <= maxTime; newTick = moment(newTick).add(unitStepSize, "h")) {
        let label = (newTick.diff(fixedDate, "h") / unitFactorToHour) % (unitStepSize * userChartOptions.scales.xAxes[0].ticks.minorToMajor) ? "" :
          labelGenerator(newTick);
        ticks.push({
          label: label,
          value: newTick.valueOf(),
          major: false
        });
      }

      scale._ticks = ticks;
    }


    /*
     * Function replaces the default generated ticks for y axis
     * by making sure they align with a stepSize
     */
    var GenerateYTicks = function (scale) {
      if (!scale || !chart) { return; }

      var ticksAsNumbers = [];
      var ticks = [];

      const preferredStepSize = chart.options.scales.yAxes[0].ticks.stepSize;
      const minorToMajor = userChartOptions.scales.yAxes[0].ticks.minorToMajor;

      const maxValue = chart.options.scales.yAxes[0].ticks.max;
      const minValue = chart.options.scales.yAxes[0].ticks.min;

      // get the max tick that will be less than max chart value
      var maxTick = Math.floor((maxValue / preferredStepSize)) * preferredStepSize;

      for (var tick = maxTick; tick > minValue; tick -= preferredStepSize) {
        ticksAsNumbers.push(tick);
        // TODO: make the formatting a user option
        ticks.push((Math.round(tick * 100) / 100).toFixed(2));
      }
      scale._ticks = ticks.map(tick => ({ label: RoundNumberTo(tick / (preferredStepSize * minorToMajor), 4) % 1 === 0 ? tick : "", major: false }));
      scale.ticks = scale._ticks.map(tick => tick.label);
      scale.ticksAsNumbers = ticksAsNumbers;
      scale.zeroLineIndex = ticksAsNumbers.indexOf(0);    // IMPORTANT: if 0 tick exists update the index location
    }


    ChartJS.defaults.line.spanGaps = false;       // global option not to connect lines when values are missing between minutes

    var annotationLines = [];
    if (chartOptions !== undefined) {
      annotationLines = chartOptions.annotation.annotations;
    }

    // Chart specific options - copy most of them from userChartOptions
    chartOptions =
      {
        responsive: userChartOptions.responsive,
        maintainAspectRatio: userChartOptions.maintainAspectRatio,
        chartArea: userChartOptions.chartArea,
        animation: {
          duration: 0, // general animation time
        },
        title: userChartOptions.title,
        legend: {
          onClick: (userChartOptions.legend.toggle ? (userChartOptions.legend.onClick ? userChartOptions.legend.onClick :
            ChartJS.defaults.global.legend.onClick) : null) ,   
          position: userChartOptions.legend.position,
          display: userChartOptions.legend.display,
        },
        layout: userChartOptions.layout,
        scales: {
          yAxes: [{
            color: userChartOptions.scales.yAxes[0].color,
            gridLines: userChartOptions.scales.yAxes[0].gridLines,
            ticks: {
              max: userChartOptions.scales.yAxes[0].ticks.max,
              min: userChartOptions.scales.yAxes[0].ticks.min,
              stepSize: userChartOptions.scales.yAxes[0].ticks.stepSize,
              fontColor: userChartOptions.scales.yAxes[0].ticks.fontColor,
              fontSize: userChartOptions.scales.yAxes[0].ticks.fontSize,
              fontFamily: userChartOptions.scales.yAxes[0].ticks.fontFamily,
              beginAtZero: userChartOptions.scales.yAxes[0].ticks.beginAtZero,
              //callback: undefined,
            },
            scaleLabel: userChartOptions.scales.yAxes[0].scaleLabel,
            // function to generate y ticks should be called here as the .ticks and ._ticks arrays
            // of the y scale won't get touched after this
            beforeCalculateTickRotation: function (chartScale) {
              GenerateYTicks(chartScale);
            },
          }],
          xAxes: [{
            color: userChartOptions.scales.xAxes[0].color,
            type: userChartOptions.scales.xAxes[0].type,
            scaleLabel: userChartOptions.scales.xAxes[0].scaleLabel,
            ticks: {
              fontColor: userChartOptions.scales.xAxes[0].ticks.fontColor,
              fontSize: userChartOptions.scales.xAxes[0].ticks.fontSize,
              fontFamily: userChartOptions.scales.xAxes[0].ticks.fontFamily,
              autoSkip: userChartOptions.scales.xAxes[0].ticks.autoSkip,
              maxRotation: userChartOptions.scales.xAxes[0].ticks.maxRotation,                 // do not rotate labels

            },
            // function to generate x ticks should be called here as the .ticks and ._ticks arrays
            // of the x scale won't get touched after this by Chart.js library
            beforeCalculateTickRotation: function (chartScale) {
              GenerateXTicks(chartScale);
            },
            gridLines: userChartOptions.scales.xAxes[0].gridLines,
            time: userChartOptions.scales.xAxes[0].time,
          }]
        },
        annotation: {
          annotations: annotationLines,
        },
        tooltips: userChartOptions.tooltips,
        draw: {
          enabled: userChartOptions.draw.enabled,
          drawingLineFunction: DrawingLineFunction,
          drawPointFunction: DrawPoint,
          redrawFunction: RedrawPoints,
          startDrawFunction: StartDrawingLine,
          datasetIndex: userChartOptions.draw.datasetIndex,
          thickness: userChartOptions.draw.thickness,
          color: userChartOptions.draw.color,
        },
        shift: {
          enabled: userChartOptions.shift.enabled,
          mode: userChartOptions.shift.mode,
          datasetIndex: userChartOptions.shift.datasetIndex,
          startShiftFunction: StartShiftingLine,
          shiftingLineFunction: ShiftingLineFunction,
        },

        zoom: userChartOptions.zoom,
        pan: userChartOptions.pan,
        plugins: userChartOptions.plugins,
      };
  }

  /*
  * Initialize needed chart plugins. 1) To paint chart area different colour.
  * 2) Redraw points currently being drawn by user (in case chart needs to be redrawn in middle of action)
  * 3) Allows for colouring zero x and y axis different colour than gridlines
  * 4) Plugin to allow for panning only with SHIFT pressed when draw (drawing) option is enabled. Otherwise
  * it will allow panning without SHIFT
  */
  var InitializeChartPlugins = function () {
    chartPlugins = [];

    //plugin for converting min/max time limits to tickvalue instead of Moment object which causes an issue
    //with moment-timezone
    chartPlugins.push({
      beforeUpdate: function(chart, easing){
        if(chart.options.scales.xAxes[0].time.min._i){
          chart.options.scales.xAxes[0].time.min = chart.options.scales.xAxes[0].time.min._i;
        }
        if(chart.options.scales.xAxes[0].time.max._i){
          chart.options.scales.xAxes[0].time.max = chart.options.scales.xAxes[0].time.max._i;
        }
      }
    })

    //plugin for background graph area
    chartPlugins.push({
      beforeDraw: function (chart, easing) {
        if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
          var ctx = chart.chart.ctx;
          var chartArea = chart.chartArea;

          ctx.save();
          ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
          ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

          // add border around chart area - ie. so that we see black border on top and right parts of graph
          ctx.strokeStyle = "#000";
          ctx.strokeRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

          ctx.restore();
        }
      }
    });


    // plugin for re drawing points that were dragged by user
    // only do this if the draw functionality for the chart was enabled
    chartPlugins.push({
      afterDraw: function (chart, easing) {
        if (chart.options.draw.enabled) {
          chart.options.draw.redrawFunction(chart);
        }
      }
    });

    // plugin for axis color option.
    chartPlugins.push({
      afterDraw: function (chart, easing) {

        if (chart.config.options && chart.config.options.scales) {
          if (chart.config.options.scales.yAxes) {
            chart.config.options.scales.yAxes.forEach(function (yAxisConfig) {
              if (!yAxisConfig.color)
                return;

              var ctx = chart.chart.ctx;
              var chartArea = chart.chartArea;
              var yAxis = chart.scales[yAxisConfig.id];

              // this code takes care of only colouring the y axis and not the rest of the horizontal gridlines
              // it does this by setting a clip area of the canvas that's just the y axis
              // then using the axis draw method to draw all the y gridlines with selected color
              // finally restoring the rest of the unclipped area to make sure the actual gridlines didn't get affected by
              // the y axis color
              ctx.save();

              ctx.beginPath();
              ctx.rect(0, 0, chartArea.left + yAxisConfig.gridLines.lineWidth + 1, chartArea.bottom + yAxisConfig.gridLines.lineWidth + 1);
              ctx.clip();

              // now let's colour the y axis
              var color = yAxisConfig.gridLines.color;
              yAxisConfig.gridLines.color = yAxisConfig.color;
              yAxis.draw(chartArea);
              yAxisConfig.gridLines.color = color;
              ctx.closePath();
              ctx.restore();
            });
          }

          if (chart.config.options.scales.xAxes) {
            chart.config.options.scales.xAxes.forEach(function (xAxisConfig) {
              if (!xAxisConfig.color)
                return;

              var ctx = chart.chart.ctx;
              var chartArea = chart.chartArea;
              var xAxis = chart.scales[xAxisConfig.id];

              ctx.save();
              ctx.beginPath();
              ctx.rect(0, chartArea.bottom, chartArea.right + xAxisConfig.gridLines.lineWidth - 1, chartArea.bottom + xAxisConfig.gridLines.lineWidth - 1);
              ctx.clip();

              // just draw the scale again with different colors
              var color = xAxisConfig.gridLines.color;
              xAxisConfig.gridLines.color = xAxisConfig.color;
              xAxis.draw(chartArea);
              xAxisConfig.gridLines.color = color;
              ctx.closePath();
              ctx.restore();
            });
          }
          // we need to draw the tooltip so that it comes over the (redrawn) elements
          //chart.tooltip.transition(easing).draw();
        }
      }
    }
    );

    /*
    * This plugin is for enabling the events around moving (redrawing) parts of a dataset, and
    * the enabling of pan with shift key
    */
    var RedrawShiftPlugin = {
      beforeInit: function (chart) {

        // if draw enabled, then add event to canvas to be able to draw lines
        if (chart.options.draw.enabled) {
          $(chart.canvas).off("mousedown").on("mousedown", chart.options.draw.startDrawFunction);
        }

        // shifting event setup if enabled
        if (chart.options.shift.enabled) {
          $(document).keyup(function (e) {
            if (e.which === 17 && chart.options.shift.enabled) { // ctrl up
              if (chart.options.draw.enabled !== true) {       // if draw disabled, enable pan after CTRL up
                chart.options.pan.enabled = true;
              }
              $(chart.canvas).off("mousedown").on("mousedown", chart.options.draw.startDrawFunction);
            }
          });

          $(document).keydown(function (e) {
            if (e.which === 17 && chart.options.shift.enabled) { // ctrl down
              chart.options.pan.enabled = false;
              // take out all mouse down events, and add the chart's startShiftFunction as we are about to 
              // start shifting
              $(chart.canvas).off("mousedown").on("mousedown", chart.options.shift.startShiftFunction);
            }
          });
        }

        // if pan is also enabled then disable it, and add the SHIFT key events, to
        // ensure it's toggled on and off in order to enable panning when SHIFT is down
        if (chart.options.draw.enabled && userChartOptions.pan.enabled) {
          chart.options.pan.enabled = false;
          $(document).keydown(function (e) {
            if (e.which === 16) { // shift down
              if (chart.options.pan.enabled === false) {
                chart.options.pan.enabled = true;
              }
              $(chart.canvas).off("mousedown");
            }
          });

          $(document).keyup(function (e) {
            if (e.which === 16) { // shift up
              if (chart.options.pan.enabled === true) {
                chart.options.pan.enabled = false;
              }
              $(chart.canvas).off("mousedown").on("mousedown", chart.options.draw.startDrawFunction);
            }
          });

        }
      }
    };

    chartPlugins.push(RedrawShiftPlugin);

    /*
    * This plugin is used to update the stepSize for y-axes, when zooming
    * so that we don't get squished lines or lines that are too far between
    */
    if (userChartOptions.scales.yAxes[0].ticks.dynamicStepSize) {
      var yDynamicStepSizePlugin = {
        afterUpdate: function (chart) {
          var minValue = chart.options.scales.yAxes[0].ticks.min
          var maxValue = chart.options.scales.yAxes[0].ticks.max
          var stepSize = CustomVerticalStepSize ?
            CustomVerticalStepSize(minValue, maxValue, chart.options.scales.yAxes[0].ticks) :
            CalculateVerticalStepSize(minValue, maxValue);

          chart.options.scales.yAxes[0].ticks.stepSize = parseFloat((stepSize / userChartOptions.scales.yAxes[0].ticks.minorToMajor).toFixed(2));
        },
      };

      chartPlugins.push(yDynamicStepSizePlugin);
    }

        /*
    * This plugin is used to update the stepSize for y-axes, when zooming
    * so that we don't get squished lines or lines that are too far between
    */
   if (userChartOptions.scales.xAxes[0].ticks.dynamicStepSize) {
    var xDynamicStepSizePlugin = {
      afterUpdate: function (chart) {
        var minValue = chart.options.scales.xAxes[0].time.min
        var maxValue = chart.options.scales.xAxes[0].time.max
        var stepSize = CustomHorizontalStepSize ?
          CustomHorizontalStepSize(minValue, maxValue, chart.options.scales.xAxes[0].ticks) :
          chart.options.scales.xAxes[0].time.unitStepSize * userChartOptions.scales.xAxes[0].ticks.minorToMajor;

        chart.options.scales.xAxes[0].time.unitStepSize = parseFloat((stepSize / userChartOptions.scales.xAxes[0].ticks.minorToMajor).toFixed(2));
      },
    };

    chartPlugins.push(xDynamicStepSizePlugin);
  }

    /*
    * Function is responsible for "inserting" the annotations for gridlines
    * into the chart.elements object so that the annotation plugin can find them
    * and draw them in the next phase
    */
    var AnnotationMidRefreshPlugin = {
      afterScaleUpdate: function (chart) {
        var annotationTypes = ChartJS.Annotation.types;
        var ns = chart.annotation
        var annotationRefreshFunction = function (annotation) {
          var id = annotation.id || Math.random().toString(36).substr(2, 6);

          // No element with that ID exists, and it's a valid annotation type
          //if (!ns.elements[id] && annotationTypes[annotation.type]) {
            var cls = annotationTypes[annotation.type];
            var element = new cls({
              id: id,
              options: annotation,
              chartInstance: chart,
            });
            element.initialize();
            element.configure();
            ns.elements[id] = element;
            annotation.id = id;
         // } else if (ns.elements[id]) {
            // annotation element already exists - just update its options object
            // and reconfigure it (NOTE: might have to do annotation.label = merge with Chart.Annotation.labelDefaults)
            // like below if the element's label changed). Since we are only doing gridline annotations here (no labels)
            // we don't worry about it
         //   element = ns.elements[id];
        //    element.options = annotation;
         //   element.configure();
          //}
        };

        // keep a copy of the non-gridline annotations
        var copiedAnnotationElements = [];
        chartOptions.annotation.annotations.forEach(function (annotation) {
          var copiedElement = ns.elements[annotation.id]
          if (copiedElement) {
            annotation.label = ChartJS.helpers.configMerge(ChartJS.Annotation.labelDefaults, annotation.label);
            copiedElement.options = annotation;
            copiedElement.configure();
            copiedAnnotationElements.push(copiedElement);
          }
        });

        // delete all annotation elements - so that we can put 
        // non gridline annotations last and hence they can be drawn 'above'
        // gridline annotations even if they occur in same draw event
        ns.elements = {}

        var horizontalGridlines = userChartOptions.scales.yAxes[0].gridLines.majorEnabled ?
          GetMajorHorizontalGridlines() : [];
        var verticalGridlines = userChartOptions.scales.xAxes[0].gridLines.majorEnabled ?
          GetMajorVerticalGridlines() : [];

        horizontalGridlines.forEach(annotationRefreshFunction);
        verticalGridlines.forEach(annotationRefreshFunction);

        copiedAnnotationElements.forEach(function (copiedElement) {
          ns.elements[copiedElement.id] = copiedElement;
        });

        // NEW - need to update the chart's ticksAsNumbers array to match the potentially shifted
        // ticks that were calibrated
        //if (chart.options.scales.yAxes[0].ticks.offset) {
        //  console.log(chart.scales["y-axis-0"].ticksAsNumbers);
        //  console.log(chart.scales["y-axis-0"].ticks);
        //  chart.scales["y-axis-0"].ticksAsNumbers.forEach(function (tickValue, index, tickArray) {
        //    tickArray[index] += chart.options.scales.yAxes[0].ticks.offset;
        //    if (index === 0) {
        //      tickArray[index] += chart.options.scales.yAxes[0].ticks.offsetTopTick;
        //    } else if (index === tickArray.length - 1) {
        //      tickArray[index] += chart.options.scales.yAxes[0].ticks.offsetBottomTick;
        //    }
        //  });
        //}

      },
    };

    chartPlugins.push(AnnotationMidRefreshPlugin);

  }


  /*
  * Initializes the draw tool tip
  */
  var InitializeDrawTooltip = function () {
    // set up the tooltip responsible for showing coordinates
    coordTooltip = $(document.createElement('div'));
    coordTooltip.html('(x, y)');
    coordTooltip.css({
      'font-weight': 'bold',
      'font-size': '14px',
      'position': 'absolute',
      'width': '100px',
      'height': '10px',
    })
    $(canvasDOMElement).parent().append(coordTooltip);
    coordTooltip.hide();
  }

  this.GetOptions = function () {
    return chart.options;
  }

  /*
  * Function resets the chart back to the empty state. Resets chart options
  * etc. needed to get it to look as in empty state.
  */
  this.ResetEmptyChart = function () {
    if (!chart) {
      return;
    }

    // reset timeShift
    shiftPoint = { t: 0, y: 0 };

    InitializeChart()

  }

  this.UpdateSize = function () {
    chart.resize();
  }

  this.ResetChart = function () {
    if (!chart) {
      return;
    }

    // reset timeShift
    shiftPoint = { t: 0, y: 0 };

    // Call the function that gets the server data string (JSON) as an argument and plots chart
    this.ConvertServerDataToChart(rawJSONServerData);

  }


  /*************************************************************************************************/
  /*************************************************************************************************/


  /*************************************************************************************************/
  /************************* 5.0 HELPER CHART AXIS FUNCTIONS ***************************************/
  /*************************************************************************************************/

  function GetMajorHorizontalGridlines() {

    if (!chart) {
      return [];
    }

    var gridlineColour = userChartOptions.scales.yAxes[0].gridLines.majorColour ?
      userChartOptions.scales.yAxes[0].gridLines.majorColour : '#000';
    var majorYlabels = chart.scales["y-axis-0"]._ticks
      .filter((function (tick) { return tick.label !== "" }))
      .map((function (tick) { return parseFloat(tick.label) }));
    var horizontalGridlines = [];
    for (var i = majorYlabels.length - 1; i >= 0; i--) {
      var gridline = HorizontalGridline();
      gridline.value = parseFloat(majorYlabels[i].toFixed(2));
      gridline.id = gridline.value ? gridline.value : gridline.value + ".";
      gridline.borderColor = gridlineColour;
      horizontalGridlines.push(gridline);
    }
    return horizontalGridlines;
  }

  function GetMajorVerticalGridlines() {
    if (!chart) {
      return [];
    }

    var gridlineColour = userChartOptions.scales.xAxes[0].gridLines.majorColour ?
      userChartOptions.scales.xAxes[0].gridLines.majorColour : '#000';
    var majorXlabels = chart.scales["x-axis-0"]._ticks
      .filter((function (tick) { return tick.label !== "" }))
      .map((function (tick) { return moment(tick.value) }));
    var verticalGridlines = [];
    for (var i = majorXlabels.length - 1; i >= 0; i--) {
      var gridline = VerticalGridline();
      gridline.id = moment(majorXlabels[i]).valueOf();
      gridline.value = moment(majorXlabels[i]);
      gridline.borderColor = gridlineColour;
      verticalGridlines.push(gridline);
    }

    return verticalGridlines;
  }

  // Currently not in use - left here for future use just in case. Problem with code is that 
  // when we pan or zoom, we don't know where our first major gridline is. We could somehow get it from
  // the callback to ticks generation....
  /*function DrawMinorGridlines(){
      if(chartOptions.scales.xAxes[0].minorToMajor < 2){
          return;
      }
      
      if(chart==undefined){
          return;
      }
      
      for(var i = chartOptions.annotation.annotations.length - 1; i >= 0; --i){
          var annotation = chartOptions.annotation.annotations[i];
          if(annotation.id.includes("minorGridline")){
              chartOptions.annotation.annotations.splice(i,1);
          }
      }
          
      // get vertical gridlines
      var minTime = moment(chartOptions.scales.xAxes[0].time.min);
      var maxTime = moment(chartOptions.scales.xAxes[0].time.max);
      var minorTimeStepHours =  GetTimeUnitHours()*userChartOptions.scales.xAxes[0].time.unitStepSize/userChartOptions.scales.xAxes[0].ticks.minorToMajor;
              
      
      var minorGridline = VerticalGridline();   
      minorGridline.value = moment(majorGridlineMinTime).toDate();
      minorGridline.id = 'minorGridline' + majorGridlineMinTime;
      minorGridline.borderColor = '#ff0000';
      minorGridline.borderWidth = chart.options.scales.xAxes[0].gridLines.lineWidth;  
      verticalGridLines.push(minorGridline);       
                  
      var minorTime = moment(majorGridlineMinTime).add(-minorTimeStepHours, "h");
      while(minTime < minorTime){
          var minorGridline = VerticalGridline();   
          minorGridline.value = moment(minorTime).toDate();
          minorGridline.id = 'minorGridline' + minorTime;
          minorGridline.borderColor = chart.options.scales.xAxes[0].gridLines.color;
          minorGridline.borderWidth = chart.options.scales.xAxes[0].gridLines.lineWidth;  
          verticalGridLines.push(minorGridline);              
          minorTime.add(-minorTimeStepHours, "h");            
      }
      
      minorTime = moment(majorGridlineMaxTime).add(minorTimeStepHours, "h");        
      while(maxTime > minorTime){
          minorGridline = VerticalGridline();   
          minorGridline.value = moment(minorTime).toDate();
          minorGridline.id = 'minorGridline' + minorTime;
          minorGridline.borderColor = chart.options.scales.xAxes[0].gridLines.color;
          minorGridline.borderWidth = chart.options.scales.xAxes[0].gridLines.lineWidth;  
          verticalGridLines.push(minorGridline);      
          minorTime.add(minorTimeStepHours, "h");
                                      
      }
      
      for(var i = 1; ;i++){
          if(i % userChartOptions.scales.xAxes[0].ticks.minorToMajor != 0){
              var minorTime = moment(majorGridlineMinTime).add(i*minorTimeStepHours, "h");

              if(minorTime < majorGridlineMaxTime){
                  minorGridline = VerticalGridline();   
                  minorGridline.value = minorTime.toDate();
                  minorGridline.id = 'minorGridline' + minorTime;
                  minorGridline.borderColor = chart.options.scales.xAxes[0].gridLines.color;
                  minorGridline.borderWidth = chart.options.scales.xAxes[0].gridLines.lineWidth;  
                  
                  verticalGridLines.push(minorGridline);   
              }else{
                  break;
              }   
          }
      }  
      
      verticalGridLines.forEach(function(line, index){
          chartOptions.annotation.annotations.push(line);
      }); 
  }*/

  var HorizontalGridline = function () {
    return {
      drawTime: "beforeDatasetsDraw",
      type: "line",
      mode: "horizontal",
      scaleID: "y-axis-0",
      value: "",
      borderColor: "#000",
      borderWidth: 1,
      label: {
        // disable label
        enabled: false,
        // Background color of label, default below
        backgroundColor: 'rgba(0,0,0,0)',
        // Font family of text, inherits from global
        fontFamily: "sans-serif",
        // Font size of text, inherits from global
        fontSize: 16,
        // Font style of text, default below
        fontStyle: "bold",
        // Font color of text, default below
        fontColor: "#000",
        content: "",
        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
        position: "top",
        xAdjust: 10
      }
    }
  }

  var VerticalGridline = function () {
    return {
      drawTime: "afterDatasetsDraw",
      type: "line",
      mode: "vertical",
      scaleID: "x-axis-0",
      value: "",
      borderColor: "#000",
      borderWidth: 0.5,
      label: {
        // disable label
        enabled: false,
        // Background color of label, default below
        backgroundColor: 'rgba(0,0,0,0)',
        // Font family of text, inherits from global
        fontFamily: "sans-serif",
        // Font size of text, inherits from global
        fontSize: 16,
        // Font style of text, default below
        fontStyle: "bold",
        // Font color of text, default below
        fontColor: "#000",
        content: "",
        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
        position: "top",
        xAdjust: -80
      }
    }
  }

  function UpdateAnnotations() {
    //annotationLines.forEach(function(line, index){
    //    chartOptions.annotation.annotations.push(line);
    //});

    ExecuteAnnotationUpdateFunctions();
  }

  this.AddAnnotation = function (annotation) {
    chartOptions.annotation.annotations.push(annotation);
  }

  this.RemoveAnnotation = function (annotationId) {
    for (var i in chartOptions.annotation.annotations) {
      if (annotationId === chartOptions.annotation.annotations[i].id) {
        chartOptions.annotation.annotations.splice(i, 1);
      }
    }
  }

  // Adds a function to the AnnotationUpdateFunctions array
  this.AddAnnotationUpdateFunction = function (func) {
    AnnotationUpdateFunctions.push(func);
  }

  // Adds a function to the AxesUpdateFunctions array
  this.AddAxesUpdateFunction = function (func) {
    AxesUpdateFunctions.push(func);
  }

  // Adds a function to the General UpdateFunctions
  this.AddUpdateFunction = function (func) {
    UpdateFunctions.push(func);
  }

  // Sets the custom vertical step size function 
  this.AddCustomVerticalStepSizeFunction = function (func) {
    CustomVerticalStepSize = func;
  }

  // Sets the custom horizontal step size function 
  this.AddCustomHorizontalStepSizeFunction = function (func) {
    CustomHorizontalStepSize = func;
  }


  function ExecuteAnnotationUpdateFunctions() {
    // Call all of the registered functions that listen for annotations changes
    // and let them execute here before returning
    AnnotationUpdateFunctions.forEach(function (AnnotationUpdateFunction, index) {
      AnnotationUpdateFunction(serverData, chartOptions.annotation.annotations);
    });
  }

  function ExecuteAxesUpdateFunctions() {
    // Call all of the registered functions that need to update axes 
    AxesUpdateFunctions.forEach(function (AxesUpdateFunction, index) {
      AxesUpdateFunction(serverData, chartOptions.scales);
    });
  }

  function ExecuteUpdateFunctions() {
    // Call all of the registered functions that need to update axes 
    UpdateFunctions.forEach(function (UpdateFunction, index) {
      UpdateFunction(serverData, chartOptions);
    });
  }

  this.Destroy = function () {
    if (chart != null) {
      window.removeEventListener('resize', resizeListener);
      chart.destroy();
    }
  }

  var RoundNumberTo = function (num, decimalPlaces) {
    var divider = Math.pow(10, decimalPlaces);
    return Math.round(num * divider) / divider;
  }

  function GetTimeUnitHours() {
    var unitsFactorToHour;
    switch (userChartOptions.scales.xAxes[0].time.unit) {
      case 'minute':
        unitsFactorToHour = 1 / 60; break;
      case 'hour':
        unitsFactorToHour = 1; break;
      case 'day':
        unitsFactorToHour = 24; break;
      default:
        unitsFactorToHour = 1; break;

    }
    return unitsFactorToHour;
  }
}

export {Options, DatasetProperties, Chart};